
import { Router, Route, RouterOnChangeArgs } from 'preact-router';
import FrameListPage from './pages/frame-list';
import FrameDetailPage from './pages/frame-detail';
import { Component } from 'preact';
import ContentPage from './pages/content-page';
import ReserveFrameDialog from './components/ReserveFrameDialog';


export default class App extends Component {

  public onRouteChange(e: RouterOnChangeArgs) {
    if (e.path === '/brille/:no') {
      document.querySelector('header')?.classList.add('show-back-button');
      document.querySelector('header .back-button')?.setAttribute('href', '/brillen' + location.search);
    } else {
      document.querySelector('header')?.classList.remove('show-back-button');
    }
  }
  render() {
  return (
    <>
      <Router onChange={(e) => this.onRouteChange(e)}>
        <Route path="/" component={FrameListPage}></Route>
        <Route path="/brillen" component={FrameListPage}></Route>
        <Route path="/brille/:no" component={FrameDetailPage}></Route>
        <ContentPage default></ContentPage>
      </Router>

      <ReserveFrameDialog></ReserveFrameDialog>
    </>
  );
}
}
